import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';

import ViewIconWhite from '../../assets/svgs/ViewIconWhite';
import AnnotationIcon from '../../assets/svgs/AnnotationIcon';
import BrushIcon from '../../assets/svgs/BrushIcon';
import RefreshIcon from '../../assets/svgs/RefreshIcon';
import DocumentIcon  from '../../assets/svgs/DocumentIcon';
import DownloadIconWhite from '../../assets/svgs/DownloadIconWhite';
import ActionButton from '../../components/ActionButton/ActionButton';
import GlyphChart from '../../components/GlyphChart/GlyphChart';
import Header from '../../components/Header/Header';
import HistogramGallery from '../../components/HistogramGallery/HistogramGallery';
import Loading from '../../components/Loading/Loading';
import Modal from '../../components/Modal/Modal';
import NewExamImagesGallery from '../../components/NewExamImagesGallery/NewExamImagesGallery';
import QuantitativeAnalysis from '../../components/QuantitativeAnalysis/QuantitativeAnalysis';
import Report3dVideo from '../../components/Report3dVideo/Report3dVideo';
import ModelViewer from '../../components/ModelViewer/ModelViewer';
import ReportAttenuation from '../../components/ReportAttenuation/ReportAttenuation';
import ReportDetails from '../../components/ReportDetails/ReportDetails';
import SingleReportHeader from '../../components/SingleReportHeader/SingleReportHeader';
import SnackBar from '../../components/SnackBar/SnackBar';
import Textarea from '../../components/Textarea/Textarea';
import WebVisualizer from '../WebVisualizer/WebVisualizer';
import WebVisualizerOHIF from '../WebVisualizerOHIF/WebVisualizerOHIF';
import WebVisualizerStone from '../WebVisualizerStone/WebVisualizerStone';
import WebVisualizerDensitometry from '../WebVisualizerDensitometry/WebVisualizerDensitometry';
import WebVisualizerCNN from '../WebVisualizerCNN/WebVisualizerCNN';
import NiftiAnnotationTool from '../NiftiAnnotationTool/NiftiAnnotationTool';
import NiftiEditorTool from '../NiftiEditorTool/NiftiEditorTool';
import { useDisableBodyScroll } from '../../utils/useDisableBodyScroll';
import EXAM_MODULES from '../../data/exam-modules';

import { functions, colors } from '../../ui/variables';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import { useIsMounted } from '../../utils/useIsMounted';

import { SingleReportStyle } from './SingleReportStyle';

const SingleTomographyReport = () => {
  const history = useHistory();
  const institution = useSelector((state) => state.settings.institution);
  const isMounted = useIsMounted();
  const language = useSelector((state) => state.settings.language);
  const { id } = useParams();

  const [patientReports, setPatientReports] = useState([]);
  const [imagesExams, setImagesExams] = useState([]);
  const [justifications, setJustifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [meUser, setMeUser] = useState();
  const [report, setReport] = useState();
  const [newReport, setNewReport] = useState();
  const [reportFeedback, setReportFeedback] = useState();
  const [reportFeedbacks, setReportFeedbacks] = useState([]);
  const [reportFeedbackComments, setReportFeedbackComments] = useState('');
  const [approvedReportComments, setApprovedReportComments ] = useState('');
  const [tempFeedbackComments, setTempFeedbackComments] = useState ('');
  const [section, setSection] = useState('');
  const [selectedJustifications, setSelectedJustifications] = useState([]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [snackBarContent, setSnackBarContent] = useState();
  const [videoObject, setVideoObject] = useState({});
  const [approvedReport, setApprovedReport] = useState(false);
  const [model3dModal, setModel3dModal] = useState(false);
  const [completeSeriesModal, setCompleteSeriesModal] = useState(false);
  const [OHIFModal, setOHIFModal] = useState(false);
  const [stoneModal, setStoneModal] = useState(false);
  const [densitometryReportModal, setDensitometryReportModal] = useState(false);
  const [CNNReportModal, setCNNReportModal] = useState(false);
  const [annotationModal, setAnnotationModal] = useState(false);
  const [editionModal, setEditionModal] = useState(false);

  const refreshReportFeedbacks = async (reportId, userId) => {
    if (!reportId) {
      return;
    }

    const feedbackResponse = await Api.getReportFeedback();
    const reportReviews = (feedbackResponse || [])
      .filter((item) => item.report === reportId)
      .sort((a, b) => (a.date_created > b.date_created ? 1 : -1));

    const myFeedback = userId
      ? reportReviews.find((item) => item.user_id === userId)
      : null;

    setReportFeedbacks(reportReviews);
    setReportFeedback(myFeedback || null);
    setReportFeedbackComments(myFeedback?.comments || '');
    setTempFeedbackComments(myFeedback?.comments || '');
    setSelectedJustifications(
      myFeedback?.justifications?.map((justification) => justification.id) || []
    );
  };

  useDisableBodyScroll(completeSeriesModal);
  useDisableBodyScroll(densitometryReportModal);
  useDisableBodyScroll(CNNReportModal);
  useDisableBodyScroll(OHIFModal);
  useDisableBodyScroll(annotationModal);
  useDisableBodyScroll(editionModal);
  useDisableBodyScroll(stoneModal);
  useDisableBodyScroll(model3dModal);


  function corrigeModulos(exam) {
    if (!exam.module) {
      exam.module = EXAM_MODULES.OUTROS.key;
    } else {
      const modulos = Object.keys(EXAM_MODULES);
      const moduloEncontrado = modulos.find(mod => exam.module.includes(mod));
      if (moduloEncontrado) {
        exam.module = EXAM_MODULES[moduloEncontrado].key;
      } else {
        exam.module = EXAM_MODULES.OUTROS.key;
      }
    }
    return exam;
  }

    // Importação dos scripts do anotador
    useEffect(() => {
      const scripts = [
        { id: 'variaveis-script', src: '/js/variaveis.js' },
        { id: 'nifti-reader-script', src: '/js/nifti-reader.js' },
        { id: 'mask-utils-script', src: '/js/maskUtils.js' },
        { id: 'mouse-utils-script', src: '/js/mouseUtils.js' },
        { id: 'nifti-utils-script', src: '/js/niftiUtils.js' },
        { id: 'draw-utils-script', src: '/js/drawUtils.js' },
        { id: 'events-script', src: '/js/events.js' },
      ];
    
      scripts.forEach(({ id, src }) => {
        if (!document.getElementById(id)) {
          const script = document.createElement('script');
          script.id = id;
          script.src = src;
          script.async = true;
          document.body.appendChild(script);
        }
      });
    
      return () => {
        scripts.forEach(({ id }) => {
          const script = document.getElementById(id);
          if (script) {
            document.body.removeChild(script);
          }
        });
      };
    }, []);


  useEffect(() => {
    (async () => {
      if (id?.length) {
        if (!isMounted()) {
          return;
        }

        setLoading(true);

        // Carrega primeiro relatorio simplificado
        const reportResponse = await Api.getSimplifiedReport(id);
        const feedbackResponse = await Api.getReportFeedback()
        let currentReport = null;
        let currentUser = meUser;

        if (!currentUser) {
          currentUser = await Api.getMeUser();
          if (currentUser) {
            setMeUser(currentUser);
          }
        }

        if (reportResponse?.status === 200 && reportResponse?.data) {
          currentReport = reportResponse?.data;
        }
        
        if (reportResponse?.status === 404 || !currentReport) {
          history.push('/404-exame');
        } else if (reportResponse?.status === 200 && currentReport) {
          setNewReport(currentReport);
          setReport(currentReport);
          setApprovedReport(currentReport.accepted);
          await refreshReportFeedbacks(currentReport.id, currentUser?.id);
          setLoading(false);
        }

        // Carrega assincronamente relatorio completo, exibindo as imagens e video ao finalizar
        (async () => {
          const reportResponse = await Api.getReport(id);
          let currentReport = null;
  
          if (reportResponse?.status === 200 && reportResponse?.data) {
            currentReport = reportResponse?.data;
          }
          
          if (reportResponse?.status === 404 || !currentReport || ['CR', 'DX', 'IO'].includes(currentReport.exam.type.toUpperCase())) {
            history.push('/404-exame');
          } else if (reportResponse?.status === 200 && currentReport) {
            currentReport.exam = corrigeModulos(currentReport.exam)
                        console.log(currentReport)

            setNewReport(currentReport);
            setReport(currentReport);
            setApprovedReport(currentReport.accepted);
            await refreshReportFeedbacks(currentReport.id, currentUser?.id);
          }
        })();
      }
    })();
  }, [history, id, isMounted, meUser]);

  useEffect(() => {
    (async () => {
      if (!isMounted()) {
        return;
      }

      // setLoading(true);

      if (report?.exam?.patient?.id) {
        const response = await Api.getReportsMiniByPatient(
          report?.exam?.patient?.id
        );

        if (response?.data?.length) {          
          setPatientReports(response?.data);
        }
      }
    })();
  }, [isMounted, report?.exam?.patient?.id]);

  useEffect(() => {
    (async () => {
      if (!isMounted()) {
        return;
      }

      const response = await Api.getMeUser();

      if (response) {
        setMeUser(response);
      }
    })();
  }, [isMounted]);

  // useEffect(() => {
  //   (async () => {
  //     if (!isMounted() || isRadiography) {
  //       return;
  //     }

  //     const originalPromises = [];
  //     const classificatedPromises = [];
  //     const originalUrls = [];
  //     const classificatedUrls = [];
  //     const currentImagesExams = [];

  //     if (report?.exam?.images?.length) {
  //       const reportExamImagesSorted = report?.exam?.images?.sort((a, b) =>
  //         a.id > b.id ? 1 : -1
  //       );

  //       reportExamImagesSorted?.forEach((image) => {
  //         if (image?.value?.length) {
  //           originalPromises.push(Api.getDicomJpegById(image?.value));
  //         }
  //       });
  //     }

  //     if (report?.images?.length) {
  //       const reportImagesSorted = report?.images?.sort((a, b) =>
  //         a.id > b.id ? 1 : -1
  //       );

  //       reportImagesSorted?.forEach((image) => {
  //         if (image?.value?.length) {
  //           classificatedPromises.push(Api.getDicomJpegById(image?.value));
  //         }
  //       });
  //     }

  //     if (originalPromises?.length) {
  //       const originalResponses = await axios.all(originalPromises);

  //       if (originalResponses?.length) {
  //         originalResponses.forEach((res, index) => {
  //           if (res) {
  //             const blob = new Blob([res], { type: 'image/jpeg' });

  //             originalUrls.push({
  //               url: URL.createObjectURL(blob),
  //               index,
  //             });
  //           }
  //         });
  //       }
  //     }

  //     if (classificatedPromises?.length) {
  //       const classificatedResponses = await axios.all(classificatedPromises);

  //       if (classificatedResponses?.length) {
  //         classificatedResponses.forEach((res, index) => {
  //           if (res) {
  //             const blob = new Blob([res], { type: 'image/jpeg' });

  //             classificatedUrls.push({
  //               url: URL.createObjectURL(blob),
  //               index,
  //             });
  //           }
  //         });
  //       }
  //     }

  //     if (originalUrls?.length && classificatedUrls?.length) {
  //       for (let i = 0; i < originalUrls?.length; i += 1) {
  //         const original = originalUrls?.find((oI) => oI.index === i);
  //         const classificated = classificatedUrls?.find(
  //           (cI) => cI?.index === i
  //         );

  //         currentImagesExams.push({
  //           id: uuidV4(),
  //           original: original?.url || '',
  //           classificated: classificated?.url || '',
  //         });
  //       }
  //     }

  //     setImagesExams(currentImagesExams);
  //   })();
  // }, [isMounted, isRadiography, report?.exam?.images, report?.images]);

  useEffect(() => {
    async function fetchImages() {
      if (!isMounted()) {
        return;
      }

      if (report?.report_images?.length) {
        const currentImagesExams = [];

        const sortedImages = report.report_images.sort((a, b) => a.id - b.id);
        const originalImages = sortedImages.filter(image => image.image_type === 'original');
        const classifiedImages = sortedImages.filter(image => image.image_type === 'classified');
    
        const maxLength = Math.max(originalImages.length, classifiedImages.length);
    
        for (let i = 0; i < maxLength; i++) {
          const original = originalImages[i] ? originalImages[i].file : '';
          const classified = classifiedImages[i] ? classifiedImages[i].file : '';
    
          currentImagesExams.push({
            id: uuidV4(),
            original,
            classified,
          });
        }
        setImagesExams(currentImagesExams);

      } else {
        const originalPromises = [];
        const classificatedPromises = [];
        const originalUrls = [];
        const classificatedUrls = [];
        const currentImagesExams = [];

        if (report?.exam?.images?.length) {
          const reportExamImagesSorted = report?.exam?.images?.sort((a, b) =>
            a.id > b.id ? 1 : -1
          );

          reportExamImagesSorted?.forEach((image) => {
            if (image?.value?.length) {
              originalPromises.push(Api.getDicomJpegById(image?.value));
            }
          });
        }

        if (report?.images?.length) {
          const reportImagesSorted = report?.images?.sort((a, b) =>
            a.id > b.id ? 1 : -1
          );

          reportImagesSorted?.forEach((image) => {
            if (image?.value?.length) {
              classificatedPromises.push(Api.getDicomJpegById(image?.value));
            }
          });
        }

        if (originalPromises?.length) {
          const originalResponses = await axios.all(originalPromises);

          if (originalResponses?.length) {
            originalResponses.forEach((res, index) => {
              if (res) {
                const blob = new Blob([res], { type: 'image/jpeg' });

                originalUrls.push({
                  url: URL.createObjectURL(blob),
                  index,
                });
              }
            });
          }
        }

        if (classificatedPromises?.length) {
          const classificatedResponses = await axios.all(classificatedPromises);

          if (classificatedResponses?.length) {
            classificatedResponses.forEach((res, index) => {
              if (res) {
                const blob = new Blob([res], { type: 'image/jpeg' });

                classificatedUrls.push({
                  url: URL.createObjectURL(blob),
                  index,
                });
              }
            });
          }
        }

        if (originalUrls?.length && classificatedUrls?.length) {
          for (let i = 0; i < originalUrls?.length; i += 1) {
            const original = originalUrls?.find((oI) => oI.index === i);
            const classificated = classificatedUrls?.find(
              (cI) => cI?.index === i
            );

            currentImagesExams.push({
              id: uuidV4(),
              original: original?.url || '',
              classified: classificated?.url || '',
            });
          }
        }

      setImagesExams(currentImagesExams);

      }
    }

    fetchImages();
  
  }, [isMounted, report]);
  
  useEffect(() => {
    if (!loading) {
      const snackBarTimeout = setTimeout(() => {
        setSnackBarContent(null);
      }, 3000);

      return () => clearTimeout(snackBarTimeout);
    }

    return null;
  }, [loading]);

  useEffect(() => {
    (async () => {
      if (
        report &&
        report.exam &&
        report.exam.type &&
        report.exam.type.length
      ) {
        // if (isMounted()) {
          // setLoading(true);
        // }

        const currentJustifications = await Api.getJustificationsByExamType(
          report.exam.type
        );

        if (isMounted()) {
          if (currentJustifications && currentJustifications.length) {
            setJustifications(currentJustifications);
          }

          setLoading(false);
        }
      }
    })();
  }, [isMounted, report]);

  useEffect(() => {
    async function fetchVideo() {
      if (
        report &&
        report.video
      ) {
        const SendVideo = { content: report.video };
        setVideoObject(SendVideo);
      } else {
        if (
          report &&
          report.images_3d &&
          report.images_3d.length &&
          report.images_3d[0].length
        ) {
          await Api.getMp4Video(report.images_3d[0]).then((response) => {
            let video = '';
            video = new Blob([response], {
              type: 'video/mp4',
            });
    
            const SendVideo = { content: URL.createObjectURL(video) };
            setVideoObject(SendVideo);
          });
        }
      }
    }

    fetchVideo();

  }, [isMounted, report]);


  useEffect(() => {
    if (!loading) {
      const snackBarTimeout = setTimeout(() => {
        setSnackBarContent(null);
      }, 3000);

      return () => clearTimeout(snackBarTimeout);
    }

    return null;
  }, [loading]);

  const canApproveReport = useMemo(() => {
    return (
      institution?.id &&
      meUser &&
      meUser?.permissions_data?.some(
        (element) =>
          element.permission === 'approve_report' &&
          element.institution === institution?.id
      )
    );
  }, [institution, meUser]);

  const handleCloseModal = () => setShowReviewModal(false);

  const handleApprovedReport = (feedback) => {
    (async () => {
      setLoading(true);
      
      if (report && report.id) {
        const response = await Api.approveReport(report.id, feedback);
        if (response && response.status) {
          if (response.status === 200) {
            setApprovedReport(true);
            setSnackBarContent({
              type: 'success',
              text: `${translate('reportSuccessfullyApproved', language)}.`,
            });

            if (response && response.data) {
              setNewReport(response.data);
              setReport(response.data);
            }

            await refreshReportFeedbacks(report.id, meUser?.id);
            setLoading(false);
          } else if (response.status === 403) {
            setSnackBarContent({
              type: 'error',
              text: `${translate(
                'reportNotApprovedBecauseItHasFeedback',
                language
              )}.`,
            });
            setLoading(false);
          } else {
            setSnackBarContent({
              type: 'error',
              text: `${translate('errorApprovingReport', language)}.`,
            });
            setLoading(false);
          }
        }

        setLoading(false);
      }
    })();
  };

  const onClickSubmitRequestReview = async(feedback) => {
    setLoading(true);

    if (report && report.id && justifications && justifications.length) {

        setApprovedReportComments('')
        setTempFeedbackComments(feedback || '')
        if (reportFeedback) {
          await Api.putReportFeedback(reportFeedback.id, {
            id: reportFeedback.id,
            report: report.id,
            justifications: selectedJustifications,
            comments: feedback || '',
          }).then(() => {
            setShowReviewModal(false);
            setLoading(false);
            setSnackBarContent({
              type: 'success',
              text: `${translate('yourReviewWasSentSucessfully', language)}.`,
            });
          })
          //.finally(() => setLoading(false))
          .catch(() => {
            setLoading(false);
            setSnackBarContent({
              type: 'error',
              text: `${translate('errorSubmittingYourReview', language)}.`,
            });
          });

          await refreshReportFeedbacks(report.id, meUser?.id);
      } else {

        await Api.submitReportFeedback({
          report: report.id,
          justifications: selectedJustifications,
          comments: feedback || '',
        })
          .then(() => {
            setShowReviewModal(false);
            setLoading(false)
            setSnackBarContent({
              type: 'success',
              text: `${translate('yourReviewWasSentSucessfully', language)}.`,
            });
          })
          //.finally(() => setLoading(false))
          .catch(() => {
            setLoading(false)
            setSnackBarContent({
              type: 'error',
              text: `${translate('errorSubmittingYourReview', language)}.`,
            });
          });

        const response = await Api.disapproveReport(report.id)
        setNewReport(response);
        setApprovedReport(false);
        setLoading(false)

        await refreshReportFeedbacks(report.id, meUser?.id);
        
      }
    }
    
    setLoading(false)

  };

  const onClickJustificationItemButton = (justificationId) => {
    const currentSelectedJustifications = selectedJustifications;

    if (currentSelectedJustifications.includes(justificationId)) {
      const justificationIndexOf =
        currentSelectedJustifications.indexOf(justificationId);
      currentSelectedJustifications.splice(justificationIndexOf, 1);
    } else {
      currentSelectedJustifications.push(justificationId);
    }

    setSelectedJustifications([...currentSelectedJustifications]);
  };

  const hasReportProbability = useMemo(() => {
    if (
      report &&
      report.probability !== null &&
      report.probability !== undefined
    ) {
      return true;
    }

    return false;
  }, [report]);

  return (
    <SingleReportStyle
      className={!patientReports?.length ? 'without-header' : ''}
    >
      <Header />
      {report && patientReports?.length ? (
        <SingleReportHeader
          examType={'tomografias'}
          allReportsMini={patientReports}
          currentReport={newReport}
          reportFeedbackComments={approvedReportComments}
          // justifications={justifications}
          setLoading={setLoading}
          approvedReport={approvedReport}
          handleRequestReviewModal={() => setShowReviewModal(true)}
          handleApprovedReport={handleApprovedReport}
          setReportFeedbackComments={setApprovedReportComments}
          canApproveReport={canApproveReport}
        />
      ) : null}
      {snackBarContent &&
      snackBarContent.type &&
      snackBarContent.type.length &&
      snackBarContent.text &&
      snackBarContent.text.length ? (
        <div className="snack-bar-wrapper">
          <SnackBar type={snackBarContent.type} text={snackBarContent.text} />
        </div>
      ) : null}
      {report ? (
        <div className="report-content-grid">
          <div className="side-bar">
            <div className="report-details-section">
              <ReportDetails
                report={newReport}
                feedbacks={reportFeedbacks}
                currentUserId={meUser?.id}
                isAdmin={meUser?.type === 'ADM'}
                onFeedbacksRefresh={() => refreshReportFeedbacks(newReport?.id || report?.id, meUser?.id)}
              />
            </div>
            {report.glyph || hasReportProbability ? (
              <div className="glyph-chart-section">
                <h3 className="glyph-chart-section-title">
                  {translate('result', language)}
                </h3>
                {report.glyph ? (
                  <GlyphChart
                    glyph={report.glyph}
                    section={section}
                    setSection={setSection}
                  />
                ) : null}
              </div>
            ) : null}
            {/* Botões que mostram as séries, o estudo e faz donwload do vídeo da série */}
            
            <div className="container">

              <ActionButton
                onClick={() =>
                  setOHIFModal(true)
                }
                text={translate('viewOHIF', language)}
                icon={<ViewIconWhite />}
                textAlign="left"
              />

              {OHIFModal ? (
                <Modal
                  overlay={`${functions.rgba(colors.black, 0.7)}`}
                  theme="dark"
                  fullScreen
                  handleClose={() => setOHIFModal(false)}
                >
                  <WebVisualizerOHIF id={id} modal={true} />
                </Modal>
              ) : null}

              <div className="space" />

              <ActionButton
                onClick={() =>
                  setCompleteSeriesModal(true)
                }
                text={translate('viewCompleteSeries', language)}
                icon={<ViewIconWhite />}
                textAlign="left"
              />

              {completeSeriesModal ? (
                <Modal
                  overlay={`${functions.rgba(colors.black, 0.7)}`}
                  theme="dark"
                  fullScreen
                  handleClose={() => setCompleteSeriesModal(false)}
                >
                  <WebVisualizer id={id} modal={true} />
                </Modal>
              ) : null}

              <div className="space" />

              <ActionButton
                onClick={() =>
                  setStoneModal(true)
                }
                text={translate('viewStone', language)}
                icon={<ViewIconWhite />}
                textAlign="left"
              />

              {stoneModal ? (
                <Modal
                  overlay={`${functions.rgba(colors.black, 0.7)}`}
                  theme="dark"
                  fullScreen
                  handleClose={() => setStoneModal(false)}
                >
                  <WebVisualizerStone id={id} modal={true} />
                </Modal>
              ) : null}

              <div className="space" />
              <ActionButton
                text={translate('view3dModel', language)}
                onClick={() =>
                  setModel3dModal(true)
                }
                icon={<ViewIconWhite />}
                textAlign="left" />

              { model3dModal ? (
                  <Modal
                  overlay={`${functions.rgba(colors.black, 0.7)}`}
                  theme="dark"
                  fullScreen
                  handleClose={() => setModel3dModal(false)}
                >
                  <ModelViewer report={report}></ModelViewer>
                </Modal>
              ): null}

                <div className="space" />
                <ActionButton
                  onClick={() =>
                    setDensitometryReportModal(true)
                  }
                  text={translate('densitometry', language)}
                  icon={<DocumentIcon />}
                  textAlign="left"
                   />

              {densitometryReportModal ? (
                <Modal
                  overlay={`${functions.rgba(colors.black, 0.7)}`}
                  theme="dark"
                  fullScreen
                  handleClose={() => setDensitometryReportModal(false)}
                >
                  <WebVisualizerDensitometry id={id} modal={true} report={report} pdf={report.pdf_densitometry}/>
                </Modal>
              ) : null}
              <div className="space" />
              <ActionButton
                onClick={() =>
                  setCNNReportModal(true)
                }
                text={translate('cnn', language)}
                icon={<DocumentIcon />}
                textAlign="left"
              />
              {CNNReportModal ? (
                <Modal
                  overlay={`${functions.rgba(colors.black, 0.7)}`}
                  theme="dark"
                  fullScreen
                  handleClose={() => setCNNReportModal(false)}
                >
                  <WebVisualizerCNN id={id} modal={true} report={report} pdf={report.pdf_cnn} />
                </Modal>
              ) : null}
              <div className="space" />
                <ActionButton
                  onClick={() =>
                    setAnnotationModal(true)
                  }
                  text={translate('annotation', language)}
                  icon={<AnnotationIcon />}
                  textAlign="left"
                />
                {annotationModal ? (
                  <Modal
                    overlay={`${functions.rgba(colors.black, 0.7)}`}
                    theme="dark"
                    fullScreen
                    handleClose={() => setAnnotationModal(false)}
                  >
                    <NiftiAnnotationTool isRadiography={false} id={id} modal={true} />
                  </Modal>
                ) : null}
                <div className="space" />
                <ActionButton
                  onClick={() =>
                    // history.push(`/editar/${id}`)
                    setEditionModal(true)
                  }
                  text={translate('edition', language)}
                  icon={<BrushIcon />}
                  textAlign="left"
                />
                {editionModal ? (
                  <Modal
                    overlay={`${functions.rgba(colors.black, 0.7)}`}
                    theme="dark"
                    fullScreen
                    handleClose={() => setEditionModal(false)}
                  >
                    <NiftiEditorTool id={id} modal={true} />
                  </Modal>
                ) : null}
                <div className="space" />
               {meUser?.is_headquarters_admin && (
                 <ActionButton
                   onClick={() =>
                    Api.updateResults(report.exam.id).then(() => {
                      setSnackBarContent({
                        type: 'success',
                        text: `${translate('examUpdateRequestedSuccessfully', language)}.`,
                      });
                      setTimeout(() => setSnackBarContent(null), 3000);
                    }).catch(() => {
                      setSnackBarContent({
                        type: 'error',
                        text: `${translate('errorRequestingExamUpdate', language)}.`,
                      });
                      setTimeout(() => setSnackBarContent(null), 3000);
                    })
                   }
                   text={translate('updateResults', language)}
                   icon={<RefreshIcon />}
                   textAlign="left"
                 />
               )}
            </div>
          </div>
          <div
            className={`report-main-content`}
          >

              <div className="report-image-section">
                <Report3dVideo video={videoObject} />
              </div>

              <div className="quantitative-analysis-section">
                <QuantitativeAnalysis report={report} />
              </div>
 
              <div className="infographic-gallery-section">
                {report && report.attenuation ? (
                  <ReportAttenuation
                    attenuation={report.attenuation}
                    section={section}
                    setSection={setSection}
                  />
                ) : null}
              </div>
 
              <div className="exam-images-gallery-section">
                  <NewExamImagesGallery images={imagesExams} />
              </div>
            {report?.histogram ? (
              <div className="histogram-gallery-section">
                <HistogramGallery histogram={report?.histogram} />
              </div>
            ) : null}
            {/* ) : (
              <div className="x-ray-image-gallery">
                <LoadingSection message={translate('loadingExamImages', language)} />
              </div>
            )} */}
          </div>
        </div>
      ) : null}
      {showReviewModal ? (
        <Modal overlay="transparent" withShadow handleClose={handleCloseModal}>
          <div className="review-modal-content">
            <h4 className="review-modal-title">
              {translate('requestReview', language)}
            </h4>
            <p className="review-modal-description">
              {translate('selectOneOrMoreOptionsToGetBetterResults', language)}:
            </p>
            <div className="review-modal-justifications">
              {justifications.map((justification) => (
                <div
                  key={justification.id}
                  className="modal-justification-item"
                >
                  {justification &&
                  justification.name &&
                  justification.name.length ? (
                    <ActionButton
                      theme={
                        selectedJustifications.includes(justification.id)
                          ? 'very-dark'
                          : 'light-disabled'
                      }
                      text={translate(
                        justification.name.toLowerCase(),
                        language
                      )}
                      textAlign="left"
                      transition
                      onClick={() =>
                        onClickJustificationItemButton(justification.id)
                      }
                    />
                  ) : null}
                  {justification &&
                  justification.description &&
                  justification.description.length ? (
                    <p className="type-item-instruction">
                      {translate(
                        justification.description.toLowerCase(),
                        language
                      )}
                    </p>
                  ) : null}
                </div>
              ))}
            </div>
            <div className="review-modal-about-desagree">
              <p className="modal-about-desagree-instruction">
                {translate('tellMoreAboutDisagreeInResults', language)}.
              </p>
              <Textarea
                value={tempFeedbackComments}
                handleChange={(event) =>
                  setTempFeedbackComments(event.currentTarget.value)
                }
                placeholder={translate('typeYourFeedback', language)}
              />
            </div>
            <div className="submit-request-review">
              <ActionButton
                theme={!selectedJustifications.length ? 'disabled' : 'default'}
                text={translate('sendFeedback', language).toUpperCase()}
                disabled={!selectedJustifications.length}
                transition
                onClick={() => {
                  setReportFeedbackComments(tempFeedbackComments);
                  onClickSubmitRequestReview(tempFeedbackComments);
                }}
              />
            </div>
          </div>
        </Modal>
      ) : null}
      {loading ? <Loading /> : null}
    </SingleReportStyle>
  );
};

export default SingleTomographyReport;
